"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.auto.turn.detection': 'Auto turn detection',
    'conversation.auto.turn.detection.help': 'Automatically stop recording when silence is detected',
};
